export default function toLatinDigits(data) {
  const persianNumericRegex = /[۰-۹]/g;
  const latinOffset = '۰'.charCodeAt(0) - '0'.charCodeAt(0);

  return data.replace(persianNumericRegex, function (match) {
    return String.fromCharCode(match.charCodeAt(0) - latinOffset);
  });
}
